import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { parseToAst } from '@sleepstation/markdown'
import { findById, getParamFromUrl, replaceTokens } from '@sleepstation/utils'
import { concat, prop, reduce, when } from 'ramda'
import { isNotNil } from 'ramda-adjunct'
import pipe from 'ramda/src/pipe'
import React from 'react'
import { useLoaderData } from 'react-router-dom'
import {
  getDbasLevel,
  getDbasScoreFormatted,
  getFullQuestions,
} from '../../helpers/quiz'
import PortalPage from '../pages/PortalPage'
import Action from '../pages/portal/PortalQuiz2Results/Action'
import ConstrainedCopy from '../shared/ConstrainedCopy'
import BreakoutModuleNarrow from '../shared/breakoutModules/BreakoutModuleNarrow'
import BreakoutModuleWide from '../shared/breakoutModules/BreakoutModuleWide'
import ScoreHero from '../shared/heroes/ScoreHero'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getQuizDownloads = pipe(
  findById(`whatDoYouKnowAboutSleepResults`),
  prop(`downloads`)
)

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const formatQuestions = reduce(
  (acc, question) => concat(acc, `- ${question}\n`),
  ``
)

const getCopyForLevel = (content, level, fullQuestions) => {
  const formattedQuestions = when(isNotNil, formatQuestions, fullQuestions)
  const template = content.copy[level]
  const result = replaceTokens(template, { formattedQuestions })
  return parseToAst(result)
}

/* eslint-enable react/display-name, react/prop-types */

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalQuizWhatDoYouKnowAboutSleepQuizResultsModule = () => {
  const data = useLoaderData()

  const {
    portal,
    page: { content },
  } = data

  const score = getParamFromUrl(`score`)
  const highScoringQuestionsObfuscated = getParamFromUrl(`qs`)
  const fullQuestions = getFullQuestions(highScoringQuestionsObfuscated)
  const level = getDbasLevel(score, fullQuestions)

  return (
    <PortalPage
      data={data}
      showHeader={false}
      footerMargin={0}
      shouldOffsetContent={false}
    >
      <ConstrainedCopy>
        <BreakoutModuleNarrow
          hasGradient={false}
          hasBottomBorder={false}
          marginV={[1, [3, 2]]}
        >
          <ScoreHero
            score={score}
            level={level}
            formatter={getDbasScoreFormatted}
          />
        </BreakoutModuleNarrow>

        <CopyRenderer
          htmlAst={getCopyForLevel(content, level, fullQuestions)}
        />
        {
          <BreakoutModuleWide
            hasTopBorder
            hasBottomBorder={false}
            marginV={[
              [2, 0],
              [4, 0],
            ]}
            paddingV={[[1.5, 2], 3]}
          >
            <Action
              level={level}
              link={content.action.link}
              downloads={getQuizDownloads(portal.downloadsFeatured)}
              dashboardUrl={portal.helpers.getPath(`/portal/dashboard/`)}
              knowledgeBaseUrl={portal.helpers.getPath(
                `/portal/knowledge-base/`
              )}
            />
          </BreakoutModuleWide>
        }
      </ConstrainedCopy>
    </PortalPage>
  )
}

export default PortalQuizWhatDoYouKnowAboutSleepQuizResultsModule
